import React from 'react'

import { FontWeight, Text } from '@gousto-internal/citrus-react'

type RecipeCountProps = {
  count: number
  textColor?: string
}

export const RecipeCount = ({ count, textColor }: RecipeCountProps) => (
  <Text fontWeight={FontWeight.Bold} size={4} style={textColor ? { color: textColor } : undefined}>
    {count} recipe{count === 1 ? '' : 's'}
  </Text>
)
